import React, { useEffect } from 'react';

import GAException from 'src/components/GAException';
import { useLocation, matchPath } from 'react-router';

import PropTypes from 'prop-types';

import {
  Box,
  List,
  makeStyles
} from '@material-ui/core';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { logout } from 'src/actions/accountActions';

import BottomItem from './BottomItem';

import { Home, RefillMinute, QR } from './icons';
import { icon_escanearQr, icon_inicio, icon_recargaSaldo } from 'src/components/Icons/Icons';
import { CenterFocusStrongOutlined, AccountBalanceWallet } from '@material-ui/icons';

const navConfig = [
  {
    //subheader: 'Menu DIMO',
    items: [
      {
        icon: CenterFocusStrongOutlined,
        href: '/app/leer/qr',
        title: 'Escanear QR'
      },
      {
        icon: icon_inicio,
        href: '/app',
        title: 'Inicio'
      },
      {
        icon: AccountBalanceWallet,
        href: '/app/recargasaldo',
        title: 'Recarga de Saldo'
      },
    ]
  },
];

function renderBottomItems(classes, { items, ...rest }) {
  return (
    <List
      className={classes.list}
    >
      {items.reduce(
        (acc, item, index) => reduceChildRoutes({ index, acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  index,
  acc,
  pathname,
  item,
  depth = 0,
  logout
}) {
  const key = item.title + '-' + index;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <BottomItem
        depth={depth}
        icon={item.icon}
        key={key + 'Bottom-Item'}
      >
        {renderBottomItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </BottomItem>
    );
  } else {
    acc.push(
      <BottomItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        endIcon={item.endIcon}
        key={key + 'Bottom-Item'}
        info={item.info}
        title={item.title}
        onLogoutClick={item.logout ? logout : null}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.navbarButtom,
  },
  mobileDrawer: theme.menuView.mobileDrawer,
  desktopDrawer: theme.menuView.desktopDrawer,
  avatar: theme.menuView.avatar,
  listSubheader: {
    color: theme.palette.navbarLeftText,
    padding: '0'
  },
  link: {
    color: theme.palette.navbarButtomText,
  },
  logo: {
    width: 153,
    paddingTop: 30,
    '& img': {
      width: '100%!important',
    }
  },
  list:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: 0,
    color: theme.palette.navbarLeftText,
  }
}));

function NavBar({ openMobile, onMobileClose, }) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);

  const handleLogout = async () => {
    try {
      await dispatch(logout());
      history.push('/login');
    } catch (error) {
                  GAException(error);

    }
  };

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  const useLargeBottomBar = JSON.parse(localStorage.getItem("themeConfig")).useLargeBottomBar ?? true;

  const content = (
    <Box
      className={classes.root}
      height={useLargeBottomBar ? '100px' : '100%'}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      // style={
      //   {
      //     paddingBottom: '80px',
      //     paddingTop: '20px',
      //   }
      // }
    >
      {navConfig.map((config, i) => (
        <List
          key={i + '-BottomBar-List'}
          style={{
            // paddingBottom:'50px'
            padding: useLargeBottomBar ? '0 0 50px 0' : '0',

          }}
        >
          {renderBottomItems(classes, { items: config.items, pathname: location.pathname, account: account, logout: () => handleLogout() })}
        </List>
      ))}
    </Box>
  );

  return (
    <>
      {content}
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
